import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // eslint-disable-next-line no-console
  console.warn("[supabase] REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY must be set in client/.env");
}

// Browser client: uses the publishable/anon key. Subject to RLS.
export const supabase = (url && anonKey) ? createClient(url, anonKey) : null;
